const state = {
  type: null,
  message: null,
  counter: 0
}

const actions = {
  success ({ commit }, message) {
    commit('success', message)
  },
  warning ({ commit }, message) {
    commit('warning', message)
  },
  error ({ commit }, message) {
    commit('error', message)
  },
  clear ({ commit }) {
    commit('clear')
  }
}

const mutations = {
  success (state, message) {
    state.type = 'alert-success'
    state.message = message
    state.counter += 1
  },
  warning (state, message) {
    state.type = 'alert-warning'
    state.message = message
    state.counter += 1
  },
  error (state, message) {
    state.type = 'alert-danger'
    state.message = message
    state.counter += 1
  },
  clear (state) {
    state.type = null
    state.message = null
    state.counter += 1
  }
}

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
}
